import React, { useEffect, useState } from "react";
import { styled, useStyletron } from "baseui";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchOrganizationStat } from "../../redux/user/UserThunk";
import UsageCard from "../../components/usage-card/UsageCardComponent";

const StatsContainer = styled("div", {
  display: "flex",
  flexDirection: "row",
  gap: "24px",
  maxWidth: "600px",
  margin: "0 auto",
  flexWrap: "wrap",
});

const UserAccountUsageView = (props) => {
  const { t } = useTranslation();
  const { usageData, subscription } = props;
  const [templatesLimit, setTemplatesLimit] = useState(5);
  const [modelersLimit, setModelersLimit] = useState(5);
  const [storageLimit, setStorageLimit] = useState(5 * 1024 * 1024 * 1024); // Storage limit in GB

  useEffect(() => {
    props.getOrganizationStat(props.primary_org_id);
  }, [props.primary_org_id]);

  useEffect(() => {
    if (subscription?.plan === "PREMIUM") {
      setTemplatesLimit(t('usageView.unlimited'));
      setModelersLimit(t('usageView.unlimited'));
      setStorageLimit(100 * 1024 * 1024 * 1024); // Adjusted to GB
    }
  }, [subscription, t]);

  const computeStorageUsage = () => {
    const totalStorage = (usageData?.publicStorageSize ?? 0) + (usageData?.privateStorageSize ?? 0);
    return (totalStorage / (1024 ** 3)).toFixed(2); // Convert bytes to GB and format
  };

  return (
    <StatsContainer>
      <UsageCard
        usedNumber={(usageData?.publicModelersCount ?? 0) + (usageData?.privateModelersCount ?? 0)}
        limit={modelersLimit}
        variableName={t('usageView.modelers.variableName')}
      />
      <UsageCard
        usedNumber={(usageData?.publicTemplatesCount ?? 0) + (usageData?.privateTemplatesCount ?? 0)}
        limit={templatesLimit}
        variableName={t('usageView.templates.variableName')}
      />
      <UsageCard
        usedNumber={computeStorageUsage() ?? 0}
        limit={(storageLimit / (1024 ** 3)).toFixed(2)}
        variableName={t('usageView.storage.variableName')}
      />
      <UsageCard
        usedNumber={((usageData?.totalCharges ?? 0)/100).toFixed(4)}
        limit={((usageData?.totalDeposits ?? 0)/100).toFixed(4)}
        variableName={t('usageView.credits.variableName')}
      />
    </StatsContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    primary_org_id: state.user.primaryOrgId,
    usageData: state.user.orgStat,
    subscription: state.user.subscription,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrganizationStat: (org_id) => dispatch(fetchOrganizationStat(org_id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAccountUsageView);
